import { Component } from '@angular/core';
import { Router } from '@angular/router';
import module from "app/modules/corrective-maintenance/corrective-maintenance.module";

@Component({
  selector: 'app-index',
  templateUrl: './index.page.html',
  imports: module,
  standalone: true,
  styleUrls: ['./index.page.scss']
})
export class IndexPage {
  constructor(public router: Router){ }
  
  toggleMawop(routes: any){
    this.router.navigate([`/data-management/corrective-maintenance/${routes}`]);
  }
}
